"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApxPaymentsPortalWidget = void 0;
const react_1 = __importStar(require("react"));
const dangerously_set_html_content_1 = __importDefault(require("dangerously-set-html-content"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const utils_1 = require("../../utils");
const styles_1 = require("../html-widget/styles");
const icons_1 = require("../icons");
const link_1 = require("../link");
const page_wrapper_1 = require("../page-wrapper");
const themed_text_1 = require("../themed-text");
const styles_2 = require("./styles");
const ApxPaymentsPortalWidget = (props) => {
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    const [widgetHidden, setWidgetHidden] = (0, react_1.useState)(false);
    const deviceType = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    const emitChangePaymentButtonClickMetric = () => {
        try {
            (0, metric_helper_1.emitCountMetrics)('APXPaymentsPortalWidget', 'ChangePaymentButtonClick', 1, configStoreState.requestId, configStoreState.tenant);
            monera_app_core_1.LOGGER.debug('Change payment button click metric emitted', {
                deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                requestId: configStoreState.requestId,
                tenant: configStoreState.tenant
            });
        }
        catch (error) {
            monera_app_core_1.LOGGER.error('Failed to emit change payment button click metric', error);
        }
    };
    const onPaymentPreferenceWidgetLoadingSuccess = (props, configStoreState) => {
        const methodName = 'APXWidgetEventHandler';
        const metricName = 'Load';
        const handleInstrumentIdSelection = (instrumentId) => {
            if (instrumentId) {
                monera_app_core_1.LOGGER.debug('InstrumentId selected', instrumentId);
                if (props.onSelectInstrumentIdCallback) {
                    monera_app_core_1.LOGGER.debug('Calling onSelectInstrumentIdCallback', instrumentId);
                    props.onSelectInstrumentIdCallback(instrumentId);
                }
            }
            else {
                monera_app_core_1.LOGGER.debug('No valid instrumentId, hiding widget');
                monera_app_core_1.LOGGER.debug('Calling setWidgetHidden with true', setWidgetHidden);
                setWidgetHidden(true);
            }
        };
        const eventHandlers = {
            AuthTimeout: (event) => {
                (0, metric_helper_1.meterFatals)({
                    methodName,
                    metricName,
                    error: true,
                    requestId: configStoreState.requestId
                });
                monera_app_core_1.LOGGER.error('AuthTimeout', {
                    event,
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
            },
            Fatal: (event) => {
                (0, metric_helper_1.meterFatals)({
                    methodName,
                    metricName,
                    success: true,
                    requestId: configStoreState.requestId
                });
                monera_app_core_1.LOGGER.error('Fatal', {
                    event,
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
            },
            Done: () => {
                (0, metric_helper_1.meterFatals)({
                    methodName,
                    metricName,
                    success: true,
                    requestId: configStoreState.requestId
                });
                monera_app_core_1.LOGGER.debug('APX Payment Portal Widget loaded successfully', {
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
            },
            WorkflowState: (event) => {
                monera_app_core_1.LOGGER.debug('WorkflowState', {
                    event,
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
            },
            WidgetAction: (event) => {
                monera_app_core_1.LOGGER.debug('WidgetAction', {
                    event,
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
            },
            WidgetContinuableStatusEvent: (event) => {
                monera_app_core_1.LOGGER.debug('WidgetContinuableStatusEvent', {
                    event,
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
            },
            UpdateSelectedCardData: (event) => {
                monera_app_core_1.LOGGER.debug('UpdateSelectedCardData', {
                    event,
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
            },
            PaymentPlanSelected: (event) => {
                monera_app_core_1.LOGGER.debug('PaymentPlanSelected', {
                    event,
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
                let instrumentId = undefined;
                if (event.isValid) {
                    monera_app_core_1.LOGGER.debug('PaymentPlanSelected isValid', {
                        isValid: event.isValid,
                        deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                        requestId: configStoreState.requestId
                    });
                    if (event.instrumentId) {
                        instrumentId = event.instrumentId;
                        monera_app_core_1.LOGGER.debug('PaymentPlanSelected selectedInstrumentId', {
                            instrumentId,
                            deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                            requestId: configStoreState.requestId
                        });
                        if (props.onSelectInstrumentIdCallback) {
                            monera_app_core_1.LOGGER.debug('SelectedInstrumentIdsEvent onSelectInstrumentIdCallback call', {
                                instrumentId,
                                deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                                requestId: configStoreState.requestId
                            });
                            props.onSelectInstrumentIdCallback(instrumentId);
                        }
                    }
                }
                if (!instrumentId) {
                    monera_app_core_1.LOGGER.debug('PaymentPlanSelected no instrumentId', {
                        instrumentId,
                        deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                        requestId: configStoreState.requestId
                    });
                    setWidgetHidden(true);
                }
                handleInstrumentIdSelection(instrumentId);
            },
            SelectedInstrumentIdsEvent: (event) => {
                monera_app_core_1.LOGGER.debug('SelectedInstrumentIdsEvent', event);
                let instrumentId = undefined;
                if (event.instrumentIds && event.instrumentIds.length > 0) {
                    monera_app_core_1.LOGGER.debug('SelectedInstrumentIdsEvent isValid');
                    instrumentId = event.instrumentIds[0];
                }
                handleInstrumentIdSelection(instrumentId);
            }
        };
        window.PaymentsPortal2Config = {
            onWidgetCreated: [
                function (widget) {
                    window.PaymentPortalWidget = widget;
                    for (const [event, handler] of Object.entries(eventHandlers)) {
                        if (typeof event === 'string' && typeof handler === 'function') {
                            widget.on(event, handler);
                        }
                        else {
                            monera_app_core_1.LOGGER.warn('Invalid event or handler detected', { event, handler });
                        }
                    }
                }
            ]
        };
        if (!props.doNotModifyApxHtml) {
            modifyHtml();
        }
    };
    const modifyHtml = () => {
        monera_app_core_1.LOGGER.debug('modifyHtml', {
            deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
            requestId: configStoreState.requestId
        });
        const widgetContainer = document.querySelector('[data-cy="apx-widget-html-container"]');
        if (widgetContainer) {
            monera_app_core_1.LOGGER.debug('Found widgetContainer', {
                widgetContainer,
                deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                requestId: configStoreState.requestId
            });
            const link = widgetContainer.querySelector('.pmts-custom-link-button');
            if (link) {
                monera_app_core_1.LOGGER.debug('Found link', {
                    link,
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
                link.remove();
            }
            const buttonInner = widgetContainer.querySelector('.a-button-inner');
            if (buttonInner) {
                monera_app_core_1.LOGGER.debug('Found buttonInner', buttonInner);
                buttonInner.style.cursor = 'auto';
                const linkMobile = buttonInner.querySelector('.a-icon');
                if (linkMobile) {
                    monera_app_core_1.LOGGER.debug('Found linkMobile', linkMobile);
                    linkMobile.remove();
                }
                const input = buttonInner.querySelector('input');
                if (input) {
                    monera_app_core_1.LOGGER.debug('Found input', input);
                    input.remove();
                }
                const buttonText = buttonInner.querySelector('.a-button-text');
                if (buttonText) {
                    monera_app_core_1.LOGGER.debug('Found buttonText', buttonText);
                    buttonText.style.padding = '0';
                }
            }
            const buttonSpan = widgetContainer.querySelector('.pmts-portal-purchase-summary-instrument-change-link');
            if (buttonSpan) {
                monera_app_core_1.LOGGER.debug('Found button', buttonSpan);
                buttonSpan.className = 'pmts-portal-purchase-summary-instrument-change-link';
            }
            const paymentMethodTitle = widgetContainer.querySelector('form .a-column:first-child h3');
            if (paymentMethodTitle) {
                monera_app_core_1.LOGGER.debug('Found paymentMethodTitle', paymentMethodTitle);
                paymentMethodTitle.remove();
            }
            const paymentMethodTitleMobile = widgetContainer.querySelector('.a-section h3');
            if (paymentMethodTitleMobile) {
                monera_app_core_1.LOGGER.debug('Found paymentMethodTitleMobile', paymentMethodTitleMobile);
                paymentMethodTitleMobile.remove();
            }
            const addressDiv = widgetContainer.querySelector('form .a-span-last');
            if (addressDiv) {
                monera_app_core_1.LOGGER.debug('Found addressDiv', {
                    addressDiv,
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
                addressDiv.remove();
            }
            const paymentColumn = widgetContainer.querySelector('.a-span6:not(.a-span-last)');
            if (paymentColumn) {
                monera_app_core_1.LOGGER.debug('Found paymentColumn', {
                    paymentColumn,
                    deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                    requestId: configStoreState.requestId
                });
                paymentColumn.style.width = '100%';
                paymentColumn.style.marginRight = '0';
            }
            const addressElementMobile = widgetContainer.querySelector('[data-address-id]');
            if (addressElementMobile) {
                monera_app_core_1.LOGGER.debug('Found addressElement', addressElementMobile);
                addressElementMobile.remove();
            }
            const paymentPreferenceContainers = document.querySelectorAll('[class*="PaymentPreferencePageUrlLinkContainer"]');
            paymentPreferenceContainers.forEach((container) => {
                const clickableElements = container.querySelectorAll('a, button, [role="button"]');
                clickableElements.forEach((element) => {
                    monera_app_core_1.LOGGER.debug('Found payment preference button', {
                        element,
                        containerClass: container.className,
                        deviceType: deviceType === null || deviceType === void 0 ? void 0 : deviceType.toString(),
                        requestId: configStoreState.requestId
                    });
                    element.removeEventListener('click', emitChangePaymentButtonClickMetric);
                    element.addEventListener('click', emitChangePaymentButtonClickMetric);
                });
            });
        }
    };
    (0, react_1.useEffect)(() => {
        onPaymentPreferenceWidgetLoadingSuccess(props, configStoreState);
    }, []);
    return !props.doNotModifyApxHtml ? (react_1.default.createElement(styles_2.Container, null,
        props.title && react_1.default.createElement(styles_2.TitleContainer, null, props.title),
        (0, utils_1.isMobile)(deviceType) ? (react_1.default.createElement(styles_2.PaymentPreferencePageUrlLinkContainer, { deviceType: deviceType },
            react_1.default.createElement(styles_2.StyledMobileLink, { href: props.selectPaymentPreferencePageUrl },
                react_1.default.createElement(styles_2.PaymentMethodSummaryContainer, { "data-cy": 'apx-widget-html-container', style: { display: widgetHidden ? 'none' : 'block' } },
                    react_1.default.createElement(dangerously_set_html_content_1.default, { html: props.html })),
                react_1.default.createElement(styles_1.StyledHtmlWidgetContainer, { style: { display: widgetHidden ? 'block' : 'none' } }, props.missingPaymentInstrumentText),
                react_1.default.createElement("i", { className: "a-icon a-icon-supplemental" })))) : (react_1.default.createElement("div", null,
            react_1.default.createElement(styles_2.PaymentMethodSummaryContainer, { "data-cy": 'apx-widget-html-container', style: { display: widgetHidden ? 'none' : 'block' } },
                react_1.default.createElement(dangerously_set_html_content_1.default, { html: props.html })),
            react_1.default.createElement(styles_1.StyledHtmlWidgetContainer, { style: { display: widgetHidden ? 'block' : 'none' } }, props.missingPaymentInstrumentText),
            props.selectPaymentPreferencePageUrl && (react_1.default.createElement(styles_2.PaymentPreferencePageUrlLinkContainer, null,
                react_1.default.createElement(link_1.Link, { href: props.selectPaymentPreferencePageUrl, copy: props.selectPaymentPreferencePageLinkText }))))),
        props.error && react_1.default.createElement(ErrorMessage, { message: props.error }))) : (react_1.default.createElement(dangerously_set_html_content_1.default, { html: props.html }));
};
exports.ApxPaymentsPortalWidget = ApxPaymentsPortalWidget;
const ErrorMessage = ({ message }) => {
    return (react_1.default.createElement(styles_2.ErrorMessageContainer, null,
        react_1.default.createElement(icons_1.RioAlertIcon, { alertType: "error" }),
        react_1.default.createElement(themed_text_1.ThemedSpan, { font: "base", style: { color: monera_app_core_1.Red_500 } }, message)));
};
